/**
 * useTour — hook for any component that needs to read or drive the tour.
 *
 * Most beacons only need `openBeacon(id)` + `hasBeenSeen(id)`. The full
 * provider context is exposed for advanced cases (auto-walk triggers,
 * "what's new" pulses tied to feature releases, etc.).
 */
import { useContext } from "react";
import { TourContext } from "./TourProvider";

export default function useTour() {
    const ctx = useContext(TourContext);
    if (!ctx) {
        // Soft fallback so a beacon mounted outside the provider doesn't
        // crash the page. It just no-ops.
        return {
            openBeaconId: null,
            seenBeacons: new Set(),
            language: "en",
            availableLanguages: [],
            setLanguage: () => {},
            openBeacon: () => {},
            closeBeacon: () => {},
            next: () => {},
            skip: () => {},
            startAutoWalk: () => {},
            hasBeenSeen: () => true,
            hasAutoWalked: () => true,
            getCopy: () => null,
            isAutoWalk: false,
            walkIndex: 0,
            walkSequence: null,
        };
    }
    return ctx;
}
